import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { CONSTANTS } from "../constants/constants";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class DownloadService {
  constructor(private readonly http: HttpClient) {}

  headers = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

  getDownloadReport(id: number) {
    const url =
      environment.BASE_API_URL + CONSTANTS.API.DOWNLOAD.REPORT + "/" + id;
    return this.http.request("GET", url, {
      ...this.headers,
      responseType: "blob",
    });
  }

  getDownloadDocument(id: number) {
    const url =
      environment.BASE_API_URL + CONSTANTS.API.DOWNLOAD.DOCUMENT + "/" + id;
    return this.http.request("GET", url, {
      ...this.headers,
      responseType: "blob",
    });
  }

  getDownloadShipDocument(id: number) {
    const url =
      environment.BASE_API_URL +
      CONSTANTS.API.DOWNLOAD.SHIP_DOCUMENT +
      "/" +
      id;
    return this.http.request("GET", url, {
      ...this.headers,
      responseType: "blob",
    });
  }

  getDownloadResearch(researchId: string) {
    const params = new HttpParams().set("researchId", researchId);
    const url = environment.BASE_API_URL + CONSTANTS.API.DOWNLOAD.RE_SEARCH;
    return this.http.request("GET", url, {
      ...this.headers,
      responseType: "blob",
      params,
    });
  }

  getDownloadThumbnail(id: number) {
    const url =
      environment.BASE_API_URL + CONSTANTS.API.DOWNLOAD.THUMBNAIL + "/" + id;
    return this.http.request("GET", url, {
      ...this.headers,
      responseType: "blob",
    });
  }
}
